import React from "react";
import { AJOUT_ANALYSE_SUPP, AJOUT_COMPLEMENT, CREATE_LICENCE, DETAIL_LICENCE, EDIT_LICENCE, AGENT_CONSULTER_PAGE_ROUTE, GESTION_AGENT_PAGE_ROUTE, GESTION_SUPER_VISOR_PAGE_ROUTE, NEW_AGENT_PAGE_ROUTE, NEW_SUBSCRIPTIONS_PAGE_ROUTE, NEW_SUPER_VISOR_PAGE_ROUTE, SUPER_VISOR_CONSULTER_PAGE_ROUTE, MY_PAYMENTS_PAGE_ROUTE } from "../constants/routerConstants";
import { APP_ACTIONS, NAVCODE, USER_ROLES, USER_STATUS_CODE } from "../types";

export function getPrivateRoutes() {
  return [
    {
      key: "pv_profile",
      label: "profile",
      path: "/profile",
      order: 4,
      component: React.lazy(() =>
        import("../../modules/profile/page/ProfilePage")
      ),
      icon: "assignmentInd",
      nav: [NAVCODE.LEFT],
      roles: [USER_ROLES.MANUFACTURER],
    },
    {
      key: "pv_settings",
      label: "settings",
      path: "/parametres",
      order: 5,
      component: React.lazy(() =>
        import("../../modules/settings/page/SettingsPage")
      ),
      icon: "accountSettings",
      nav: [NAVCODE.LEFT],
      roles: [USER_ROLES.MANUFACTURER,
        USER_ROLES.WORKER,
        USER_ROLES.VALIDATOR_SUPERVISOR,
        USER_ROLES.VALIDAOR_AGENT_N2,
        USER_ROLES.VALIDAOR_AGENT_N1,],
    },
    {
      key: "pv_subscription_details",
      label: "Détails d'une demande de souscription",
      path: "/details-souscription/:reference",
      component: React.lazy(() =>
        import("../../modules/subscription/pages/SubscriptionDetailsPage")
      ),
      nav: [],
      roles: [
        USER_ROLES.VALIDATOR_SUPERVISOR,
        USER_ROLES.VALIDAOR_AGENT_N2,
        USER_ROLES.VALIDAOR_AGENT_N1,
      ],
    },
    {
      key: "pv_menu_principal",
      label: "Menu principale",
      nav: [NAVCODE.SECOND_TOP],
      roles: [USER_ROLES.MANUFACTURER],
      children: [
        {
          key: "pv_menu_principal_1",
          label: "Submenu 1",
          path: "/submenu1",
          component: React.lazy(() =>
            import("../../modules/exemple/page/ExemplePage")
          ),
        },
        {
          key: "pv_menu_principal_2",
          label: "Submenu 2",
          path: "/submenu2",
          component: React.lazy(() =>
            import("../../modules/exemple/page/ExemplePage")
          ),
        },
      ],
    },
    {
      key: "pv_mon_espace",
      label: "Mon espace",
      nav: [NAVCODE.SECOND_TOP],
      roles: [USER_ROLES.MANUFACTURER],
      children: [
        {
          key: "pv_mon_espace_1",
          label: "Submenu 1",
          path: "/submenu1",
          component: React.lazy(() =>
            import("../../modules/exemple/page/ExemplePage")
          ),
        },
        {
          key: "pv_mon_espace_2",
          label: "Submenu 2",
          path: "/submenu2",
          component: React.lazy(() =>
            import("../../modules/exemple/page/ExemplePage")
          ),
        },
      ],
    },

    //Mode user complete
    {
      key: "pv_gestion_licence",
      label: "gestion licence",
      path: "/gestion-licence",
      component: React.lazy(() =>
        import("../../modules/gestionLicence/page/LicenceSearchPage")
      ),
      order: 1,
      icon: "vpnKey",
      nav: [NAVCODE.LEFT],
      isHidden: (statusCode) => statusCode != USER_STATUS_CODE.ACTIVE,
      roles: [USER_ROLES.MANUFACTURER, USER_ROLES.WORKER],
    },
    {
      key: "pv_gestion_licence_nouvelle_demande",
      label: "Nouvelle demande de licence",
      path: CREATE_LICENCE,
      component: React.lazy(() =>
        import("../../modules/gestionLicence/page/DemandeLicencePage")
      ),
      nav: [],
      roles: [USER_ROLES.MANUFACTURER, USER_ROLES.WORKER],
    },
    {
      key: "pv_gestion_licence_details",
      label: "Détails de la licence",
      path: DETAIL_LICENCE,
      component: React.lazy(() =>
        import("../../modules/gestionLicence/page/DemandeLicencePage")
      ),
      nav: [],
      roles: [USER_ROLES.MANUFACTURER, USER_ROLES.WORKER],
    },
    {
      key: "pv_gestion_licence_edit",
      label: "Modifier la licence",
      path: EDIT_LICENCE,
      component: React.lazy(() =>
        import("../../modules/gestionLicence/page/DemandeLicencePage")
      ),
      nav: [],
      roles: [USER_ROLES.MANUFACTURER, USER_ROLES.WORKER],
    },
    {
      key: "pv_add_complement_licence",
      label: "Ajout complement",
      path: AJOUT_COMPLEMENT,
      component: React.lazy(() =>
        import("../../modules/gestionLicence/page/ResolveComplementPage")
      ),
      nav: [],
      roles: [USER_ROLES.MANUFACTURER, USER_ROLES.WORKER],
    },
    {
      key: "pv_add_analyse_supp_licence",
      label: "Ajout analyse supp",
      path: AJOUT_ANALYSE_SUPP,
      component: React.lazy(() =>
        import("../../modules/gestionLicence/page/ResolveAnalysePage")
      ),
      nav: [],
      roles: [USER_ROLES.MANUFACTURER, USER_ROLES.WORKER],
    },
    {
      key: "pv_assistance",
      label: "assistance",
      path: "/assistance",
      component: React.lazy(() =>
        import("../../modules/exemple/page/ExemplePage")
      ),
      order: 2,
      icon: "help",
      nav: [],
      isHidden: (statusCode) => statusCode != USER_STATUS_CODE.ACTIVE,
      roles: [USER_ROLES.MANUFACTURER],
    },
    {
      key: "pv_gestion_forfait",
      label: "gestion forfait",
      path: "/gestion-forfait",
      component: React.lazy(() =>
        import("../../modules/exemple/page/ExemplePage")
      ),
      order: 3,
      icon: "inventory",
      nav: [],
      isHidden: (statusCode) => statusCode != USER_STATUS_CODE.ACTIVE,
      roles: [USER_ROLES.MANUFACTURER],
    },
    {
      key: "pv_gestion_utilisateurs",
      label: "worker.management",
      path: "/gestion-utilisateurs",
      component: React.lazy(() =>
        import("../../modules/worker/page/WorkerPage")
      ),
      order: 2,
      icon: "usersManagement",
      nav: [NAVCODE.LEFT],
      isHidden: (statusCode) => statusCode != USER_STATUS_CODE.ACTIVE,
      roles: [USER_ROLES.MANUFACTURER],
    },

    {
      key: "pv_mes_paiements",
      label: "my_payments",
      path: MY_PAYMENTS_PAGE_ROUTE,
      component: React.lazy(() =>
        import("../../modules/payment/MyPaymentsPage")
      ),
      order: 3,
      icon: "payment",
      nav: [NAVCODE.LEFT],
      isHidden: (statusCode) => statusCode != USER_STATUS_CODE.ACTIVE,
      roles: [USER_ROLES.MANUFACTURER],
    },

    {
      key: "pv_ajouter_utilisateur",
      path: "/ajouter-utilisateur",
      component: React.lazy(() =>
        import("../../modules/worker/page/CreateWorkerPage")
      ),
      nav: [],
      isHidden: (statusCode) => statusCode != USER_STATUS_CODE.ACTIVE,
      roles: [USER_ROLES.MANUFACTURER],
    },

    {
      key: "pv_modifier_utilisateur",
      path: "/modifier-utilisateur/:workerId",
      component: React.lazy(() =>
        import("../../modules/worker/page/UpdateWorkerPage")
      ),
      nav: [],
      isHidden: (statusCode) => statusCode != USER_STATUS_CODE.ACTIVE,
      roles: [USER_ROLES.MANUFACTURER],
    },

    {
      key: "pv_consulter_utilisateur",
      path: "/consulter-utilisateur/:workerId",
      component: React.lazy(() =>
        import("../../modules/worker/page/ViewWorkerPage")
      ),
      nav: [],
      isHidden: (statusCode) => statusCode != USER_STATUS_CODE.ACTIVE,
      roles: [USER_ROLES.MANUFACTURER],
    },

    //EXTRA
    {
      key: "pv_deconnexion",
      label: "Déconnexion",
      action: APP_ACTIONS.LOGOUT,
      nav: [NAVCODE.EXTRA],
      roles: [USER_ROLES.MANUFACTURER],
    },

    // SUperVIsor
    {
      key: "pv_sv_nouvelles_demandes",
      label: "nouvelles demandes",
      path: "/nouvelles-demandes",
      order: 1,
      component: React.lazy(() =>
        import("../../modules/subscription/pages/NouvelDemandes")
      ),
      icon: "inbox",
      nav: [NAVCODE.LEFT],
      roles: [USER_ROLES.VALIDATOR_SUPERVISOR, USER_ROLES.VALIDAOR_AGENT_N2],
    },
    // SUperVIsor Agent
    {
      key: "pv_ag_demandes_en_attente",
      label: "demandes en attente de traitement",
      path: "/demandes-en-attente",
      order: 1,
      component: React.lazy(() =>
        import("../../modules/subscription/pages/DemandesPending")
      ),
      icon: "hourglassEmpty",
      nav: [NAVCODE.LEFT],
      roles: [
        USER_ROLES.VALIDATOR_SUPERVISOR,
        USER_ROLES.VALIDAOR_AGENT_N1,
        USER_ROLES.VALIDAOR_AGENT_N2,
      ],
    },
    {
      key: "pv_ag_demandes_en_cour",
      label: "demande en cour de traitement",
      path: "/demandes-en-cour",
      order: 1,
      component: React.lazy(() =>
        import("../../modules/subscription/pages/DemandesEnProgress")
      ),
      icon: "buildCircleSharp",
      nav: [NAVCODE.LEFT],
      roles: [
        USER_ROLES.VALIDATOR_SUPERVISOR,
        USER_ROLES.VALIDAOR_AGENT_N1,
        USER_ROLES.VALIDAOR_AGENT_N2,
      ],
    },
    {
      key: "pv_ag_demandes_cloture",
      label: "demande cloture",
      path: "/demandes-cloture",
      order: 1,
      component: React.lazy(() =>
        import("../../modules/subscription/pages/DemandesClotures")
      ),
      icon: "playlistAddCheckCircle",
      nav: [NAVCODE.LEFT],
      roles: [
        USER_ROLES.VALIDATOR_SUPERVISOR,
        USER_ROLES.VALIDAOR_AGENT_N1,
        USER_ROLES.VALIDAOR_AGENT_N2,
      ],
    },

    {
      key: "pv_gestion_user",
      label: "Gestion users",
      path: GESTION_SUPER_VISOR_PAGE_ROUTE,
      order: 1,
      component: React.lazy(() =>
        import("../../modules/superVisor/pages/Gestion")
      ),
      icon: "supervisorAccount",
      nav: [NAVCODE.LEFT],
      roles: [
        USER_ROLES.ADMIN
      ],
    },
    {
      key: "pv_ajouter_supervisor",
      path: NEW_SUPER_VISOR_PAGE_ROUTE,
      component: React.lazy(() =>
        import("../../modules/superVisor/pages/CreationPage")
      ),
      nav: [],
      isHidden: (statusCode) => statusCode != USER_STATUS_CODE.ACTIVE,
      roles: [USER_ROLES.ADMIN],
    },
    {
      key: "pv_consultation_supervisor",
      path: SUPER_VISOR_CONSULTER_PAGE_ROUTE,
      component: React.lazy(() =>
        import("../../modules/superVisor/pages/ConsultationPage")
      ),
      nav: [],
      isHidden: (statusCode) => statusCode != USER_STATUS_CODE.ACTIVE,
      roles: [USER_ROLES.ADMIN],
    },
    {
      key: "pv_payment_success",
      label: "Succès du paiement",
      path: "/payment/success",
      component: React.lazy(() =>
        import("../../modules/payment/components/SuccessPayment")
      ),
      nav: [],
      roles: [USER_ROLES.MANUFACTURER],
    },
  ];
}
